export default __webpack_public_path__ + "static/media/mt_ln_3.01d055bf.png";